// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"send-cancel","clipPath":"url(#clip0_543_8122)"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 12L2 20.5L11.75 16.25M5 12L2 3.5L21.5 12L19.0625 13.0625M5 12H10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.6675 16L18.8379 18.8485M18.8379 18.8485L16.02 21.6663M18.8379 18.8485L21.6569 21.6675M18.8379 18.8485L16 16.0106","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SendCancelIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'send-cancel',
    ref,
    icon: element,
  },
));

SendCancelIcon.displayName = 'SendCancelIcon';

export default SendCancelIcon;
